import { render } from "./HorizontalItemScroll.vue?vue&type=template&id=35cf3de0&scoped=true"
import script from "./HorizontalItemScroll.vue?vue&type=script&lang=js"
export * from "./HorizontalItemScroll.vue?vue&type=script&lang=js"

import "./HorizontalItemScroll.vue?vue&type=style&index=0&id=35cf3de0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cf3de0"]])

export default __exports__